<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-bot"><span href="#/xhtml/notice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Chapter 1</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Chapter 2</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc"><span href="#/xhtml/praise#fs" title="Link target outside of Sample">Praise for <span class="epub-i">Leslie LaFoy’</span>s Delicious Historical Romances</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">St. Martin’s Paperbacks Titles by Leslie LaFoy</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?611957ed